export const environment = {
    production: false,
    apiUrl: 'https://tischreservierung-dev.copago.io/api',
    adminShowsRangeInDays: 14,
    adminConfigUrl: '/config/admin-config.json'
};